
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import ProgressBar from '@/features/shipment/components/shipmentSuccess/instructions/ProgressBar.vue';
import LottieAnimation from '@/features/common/components/LottieAnimation.vue';

@Component({
  components: {
    ProgressBar,
    LottieAnimation,
  },
})
export default class Package extends Vue {
  @Prop({ required: true }) step!: number;

  @Watch('step', { immediate: true })
  private async startInstructionsAnimation(step: number) {
    await this.$nextTick();

    const anim = this.$refs.lottieInstructionPackage;
    if (!anim) return;

    if (step === 1) {
      (anim as LottieAnimation).play();
    } else {
      (anim as LottieAnimation).stop();
    }
  }
}
